import { useCurrentGameQuery } from "../../hooks/use-current-game.ts";
import { ChangePicksButton } from "../ChangePicks/ChangePicksButton.tsx";
import { LatestEvent } from "../LatestEvent/LatestEvent.tsx";
import { PostGameMessageButton } from "../Messages/PostGameMessageButton.tsx";

/**
 * This displays different content depending on game status.
 *
 * - Before the game starts, it shows a button allowing fans to change their
 *  picks.
 * - During the game, it shows the latest updates.
 * - After the game ends, it shows a button fans can click to get their results.
 */
export const UnderCardSection = () => {
  const gameQuery = useCurrentGameQuery();

  if (gameQuery.isPending || gameQuery.isError) {
    return null;
  }

  const game = gameQuery.data;

  if (game.status === "about_to_start") {
    return <ChangePicksButton />;
  }

  if (game.status === "in_progress") {
    return <LatestEvent />;
  }

  if (game.status === "finished") {
    return <PostGameMessageButton />;
  }
};
